import { CastEducationIcon } from './CastEducationIcon';

/**
 * author: Google
 * id 31B2064A-79C9-44A7-8C5E-0490162A7864
 * name cast-education
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cast-education.svg
 * tags
 */
export const CastTutorialIcon = CastEducationIcon;
export default CastTutorialIcon